

















































































import Vue from 'vue';
import sum from 'lodash/sum';
import ItemInput from '@/components/item/ItemInput.vue';
import ItemTooltip from '@/components/item/ItemTooltip.vue';
import Enemy from '@/classes/enemy/enemy';
import Item from '@/classes/item/item';
import SiteSetting from '@/classes/siteSetting';

export default Vue.extend({
  components: { ItemInput, ItemTooltip },
  name: 'EnemyInput',
  props: {
    handleShowItemList: {
      type: Function,
    },
    enemy: {
      type: Enemy,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipItem: new Item(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  computed: {
    airPowerDetail() {
      const airPowers = this.enemy.items.map((v) => (v.data.isRecon ? 0 : v.fullAirPower));
      return airPowers.filter((v) => v > 0).length ? `( ${airPowers.join(' | ')} )` : '';
    },
    airPowerDetailAB() {
      const airPowers = this.enemy.items.map((v) => v.fullAirPower);
      return airPowers.filter((v) => v > 0).length ? `( ${airPowers.join(' | ')} )` : '';
    },
    sumSlot(): number {
      return sum(this.enemy.items.map((v) => v.fullSlot));
    },
  },
  methods: {
    showItemList(index: number): void {
      if (!this.readonly) {
        this.handleShowItemList(index);
      }
    },
    updateItem() {
      if (!this.readonly) {
        this.$emit('input', this.enemy);
      }
    },
    bootTooltip(item: Item, e: MouseEvent) {
      const setting = this.$store.state.siteSetting as SiteSetting;
      if (!item.data.id || setting.disabledItemTooltip) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('item-name')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = rect.x + rect.width / 3;
        this.tooltipY = rect.y + rect.height;
        this.tooltipItem = item;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
